import React from 'react';
import { computationDecimalScale, computationValueLength } from '../../../../common/helper';
import FormsyInputField from '../../../elements/FormsyInputField';
import FormFields from "../../formFields/computation.json";
const EXTRA_DETAILS = FormFields?.EXTRA_DETAILS;

const ExtraDetails = ({
    computationDetails,
    allfieldsReadonly,
    isRegeneratedFieldActive,
    financierId,
    lead,
    handleRadioChange,
    handlePatternFormatChange,
    handleInputChange,
}) => {
    return <section className='loan-detail-filed-bg'>
        <h2>Extra Details</h2>
        {EXTRA_DETAILS.map((field) => (
            ["text", "number-format"].includes(field.type) ? (
                <fieldset className={`form-filed ${field.label.length >= 25 ? 'col-md-12' : 'col-md-6'}`}>
                    <FormsyInputField
                        id={field.id}
                        name={field.name}
                        type={field.type}
                        value={computationDetails?.[field.name]}
                        placeholder=" "
                        {...(field.type === "number-format") ? {
                            thousandsGroupStyle: "thousand",
                            thousandSeparator: ',',
                            decimalSeparator: '.'
                        } : {}}
                        label={field.label}
                        onChange={
                            field.type === "number-format"
                                ? (data) => handlePatternFormatChange(data, field.name)
                                : handleInputChange
                        }
                        format={field.ApplyNumberformat ? field.format : ""}
                        validations={field.validations}
                        validationError={
                            computationDetails?.[field.name] ? field.validationError : ""
                        }
                        readOnly={field.readOnly || allfieldsReadonly || isRegeneratedFieldActive(field?.name)}
                        required={field.required}
                        decimalScale={computationDecimalScale(financierId)}
                        valueLength={computationValueLength(financierId)}
                    />
                </fieldset>
            ) :
                field.type === 'radio' ? (
                    <>
                        <fieldset className="form-filed col-md-12 radio-btn radio-type-txt">
                            <label className="form-label">{field.label}</label>
                            {field.options.map((option) => (
                                <div className="custom-control custom-checkbox" key={option.value}>
                                    <input
                                        id={option.value}
                                        type="radio"
                                        className="custom-control-input"
                                        name={option.name}
                                        value={option.value}
                                        defaultChecked={option.value?.toString() === lead?.leadDetail?.lead_computation_details?.[option.name] ? true : false}
                                        onChange={handleRadioChange}
                                        disabled={allfieldsReadonly || isRegeneratedFieldActive(field?.id)}
                                        aria-label={`for ${option.name}`}
                                    />
                                    <label htmlFor={option.id} className="custom-control-label">{option.label}</label>
                                </div>
                            ))}
                        </fieldset>
                    </>
                ) : null
        ))}
    </section>;
};


export default ExtraDetails;
